import axios from "axios";
const parseFilter = (filter) => {
    const parsedParams = {};
    Object.entries(filter).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
            parsedParams[key] = value;
            }
    });
    return parsedParams;
    };
export default {
    namespaced: true,
    state: {
        page: 1,
        perPage: 15,
        sortBy: '',
        sort: 'desc',
        contragent: {},
        transportationType: '',
        transportationRequests: [],
        loading:false,
        filter:{}
    },
    actions: {
        saveTransportationType({ commit }, type){
            commit('setTransportationType', type);
        },
        fetch({commit, state}) {
           commit('setLoading', true)
            let link = 'https://declarant.by/rest/user/bidcontract/'
           /* if (state.selectedUser && state.selectedUser.length) {
                if (rootState.auth.user.groups.includes('21')) {
                    link = link + `/${state.selectedUser}`
                }
            }*/
            return axios.post(link, {
                page: state.page,
                perPage: state.perPage,
                user_id:state.contragent.id,
                sort: state.sort,
                ...parseFilter(state.filter)
            }).then(res => {
                    commit('setTransportationRequests', res.data.data)
                    commit('setLoading', false)
                })
                .catch(err => {
                    commit('setLoading', false)
                    this.$notify({
                        title: 'Ошибка',
                        text: err.response.data.message,
                        type: 'error'
                    })
                })
        },
        /*
        checkTransportations(){
            return axios.get('https://declarant.by/rest/user/client/check-transportations')
        }*/
    },
    mutations: {
        setTransportationType(state, type){
            state.transportationType = type;
        },
        setContragent(state, contragent){
            state.contragent = contragent
        },
        setCreateTransportationModal(state, status){
            state.createTransportationModal = status
        },
        setFilter(state, params){
            state.filter = params
        },
        setLoading(state, status){
            if(status){
                return state.loading = status
            }
            state.loading = !state.loading
        },
        setTransportationRequests(state, items) {
            state.transportationRequests = items
        },
        setPage(state, page) {
            state.page = page
        },
        setPerPage(state, perPage) {
            if(perPage === '9999'){
                state.page = 1
            }
            state.perPage = perPage
        },
        setSorting(state, payload) {
            state.sort = payload.sort
        },
        unset(state) {
            state.page = 1;
            state.filter = {};
        },
        destroy(state) {
            state.page = 1
        },
    },
    getters: {
        getCreateTransportationModal: s => s.createTransportationModal,
        getTransportationRequests: s => s.transportationRequests,
        getContragent: s => s.contragent,
        loading: s => s.loading,
        page: s => s.page,
        perPage: s => s.perPage,
    }
}